import React from 'react';
import { useTranslation } from 'react-i18next';

const HeaderSection = () => {
    const { t } = useTranslation();

    return (
        <div className="text-center py-8">
            <h1 className="text-2xl my-2">{t('home.title', 'Supported people · Successful projects.')}</h1>
            <p className="text-gray-400 text-sm leading-6 my-4">
                {t('home.description.1', 'We work with trade pros and customers to make sure projects succeed.')}
                <br />
                {t('home.description.2', 'Turn your daydream into a job done with trades.org.')}
            </p>
        </div>
    );
};

export default HeaderSection;
